// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent---h0i9g","resetButton":"resetButton---MaHUw"};